/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 14:42:46
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-28 15:39:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/StoreVoucher/List/config.tsx
 */
// import { Tag, Image } from 'src/components/Antd';
import StatusTag from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { DropDown, Menu, MenuItem } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EDiscountType, EnumStatus } from 'src/types/common/discount';
// import { monent } from 'monent';
import { getI18nFromGeneral, replaceI18nVariables } from '@/src/tools/tools';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { EnumTablePosition } from 'src/types/common/common';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { handleOnFormatStoreTimeAndDate } from '@/src/tools/tools';
import css from './css.module.less';

const statusFilterList = [
  {
    labelKey: 'general.status.active',
    value: EnumStatus.Active,
  },
  {
    labelKey: 'general.status.draft',
    value: EnumStatus.Draft,
  },
  {
    labelKey: 'general.status.issued',
    value: EnumStatus.Issued,
  },
  {
    labelKey: 'general.status.expired',
    value: EnumStatus.Expired,
  },
];

const typeFilterList = {
  [EDiscountType.Percentage]: 'voucher.storeVoucherList_config.percentageOff',
  [EDiscountType.Reduction]:
    'voucher.storeVoucherList_config.fixedReductionAmount',
  [EDiscountType.Gift]: 'voucher.storeVoucherList_config.freeItems',
  [EDiscountType.Shipping]: 'voucher.storeVoucherList_config.shippingDiscount',
};

export enum StatusChange {
  Publish = 'Publish',
  Archive = 'Archive',
  Restore = 'Restore',
  ToDraft = 'ToDraft',
  Duplicate = 'Duplicate',
  Issue = 'Issue',
}

export enum ModalType {
  ArchiveDiscount = 'ArchiveDiscount',
  UnableToPublish = 'UnableToPublish',
}

const overlay = (data) => (
  <Menu className={css.overlay}>
    {data.map((item) => (
      <MenuItem
        className={`${css.menuItem} ${item.name?.toLowerCase()}`}
        key={item.key}
        onClick={() => item.function()}>
        {item.name}
      </MenuItem>
    ))}
  </Menu>
);
export enum FrequencyUnit {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

export const columns = (
  editFun,
  statusChange,
  statusChangeModal,
  tabsActive,
  timezoneInUTC,
  { getI18n },
) => [
  {
    title: getI18n('voucher.storeVoucherList_config.voucherNo.'),
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    default: true,
    // className: css.columnClass,
    sorter: true,
    width: 192,
    childGenerate: (text, record) => {
      return <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>;
    },
  },

  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: getI18n('voucher.storeVoucherList_config.status'),
          dataIndex: 'status',
          default: true,
          key: 'status',
          align: 'center',
          position: EnumTablePosition.mid,
          //  className: css.columnClass,
          width: 120,
          ...(tabsActive === tabsConfig[0].key ? { sorter: true } : {}),
          childGenerate: (text, record) => {
            return <StatusTag status={text} />;
          },
        },
      ]
    : []),
  {
    title: getI18n('voucher.storeVoucherList_config.customerDatabase'),
    dataIndex: 'customerDatabaseName',
    key: 'customerDatabaseName',
    default: true,
    // className: css.columnClass,

    width: 176,
    childGenerate: (text, record) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('voucher.storeVoucherList_config.type'),
    dataIndex: 'voucherType',
    default: true,
    key: 'voucherType',
    //  className: css.columnClass,
    minWidth: 180,
    childGenerate: (text, record) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={getI18n(typeFilterList[text])}>
            {getI18n(typeFilterList[text])}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: replaceI18nVariables(
            getI18n('voucher.storeVoucherList_config.startDate(GMT+11)'),
            timezoneInUTC,
          ),
          default: true,
          dataIndex: 'beginDateTime',
          key: 'beginDateTime',

          minWidth: 136,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <NoWrapContainer>
                <GlobalTooltip title={handleOnFormatStoreTimeAndDate(text)}>
                  {handleOnFormatStoreTimeAndDate(text) || '-'}
                </GlobalTooltip>
              </NoWrapContainer>
            ) : (
              '-'
            );
          },
        },
        {
          title: replaceI18nVariables(
            getI18n('voucher.storeVoucherList_config.endDate(GMT+11)'),
            timezoneInUTC,
          ),
          dataIndex: 'endDateTime',
          default: true,
          key: 'endDateTime',

          minWidth: 136,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <NoWrapContainer>
                <GlobalTooltip title={handleOnFormatStoreTimeAndDate(text)}>
                  {handleOnFormatStoreTimeAndDate(text) || '-'}
                </GlobalTooltip>
              </NoWrapContainer>
            ) : (
              '-'
            );
          },
        },
      ]
    : []),
  ...(tabsActive === EnumStatus.Archived
    ? [
        {
          title: replaceI18nVariables(
            getI18n('voucher.storeVoucherList_config.lastModified(GMT+11)'),
            timezoneInUTC,
          ),
          default: true,
          dataIndex: 'modifiedDate',
          key: 'modifiedDate',
          className: css.columnClass,
          minWidth: 136,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <NoWrapContainer>
                <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>
              </NoWrapContainer>
            ) : (
              ''
            );
          },
        },
        {
          title: replaceI18nVariables(
            getI18n('voucher.storeVoucherList_config.archived(GMT+11)'),
            timezoneInUTC,
          ),
          dataIndex: 'archivedDate',
          default: true,
          key: 'archivedDate',

          sorter: true,
          minWidth: 136,
          childGenerate: (text, record) => {
            return text ? (
              <NoWrapContainer>
                <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>
              </NoWrapContainer>
            ) : (
              ''
            );
          },
        },
      ]
    : []),

  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    key: 'actions',

    minWidth: 88,
    align: 'center',
    childGenerate: (text, record) => {
      const overlayActionNoDraftList = overlayActionNoDraft(
        record.status,
        record.uuid,
        editFun,
        statusChange,
        statusChangeModal,
        { getI18n },
      );
      return (
        <DropDown
          getPopupContainer={() => {
            if (document) return document.body;
          }}
          overlay={overlay(overlayActionNoDraftList)}
          placement='bottomRight'
          trigger={['click']}>
          <div className={css.moreActions}>
            <Icon type='iconMore'></Icon>
          </div>
        </DropDown>
      );
    },
  },
];

const overlayActionNoDraft = (
  type,
  uuid,
  editFun,
  statusChange,
  statusChangeModal,
  { getI18n },
) => {
  const canAdd = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.add_edit_voucher,
      }),
    ],
  });

  const canChangeStatus = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.archive_publish_unpublish,
      }),
    ],
  });
  const canView = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.view_voucher_details_page,
      }),
    ],
  });
  return [
    ...(canView
      ? type == EnumStatus.Draft
        ? [
            {
              name: getI18n('general.edit'),
              key: 1,
              function: () => editFun(uuid, false),
            },
          ]
        : [
            {
              name: getI18n('voucher.storeVoucherList_config.viewDetail'),
              key: 1,
              function: () => editFun(uuid, true),
            },
          ]
      : []),
    ...(canAdd
      ? type !== EnumStatus.Archived
        ? [
            // {
            //   name: getI18n('voucher.storeVoucherList_config.duplicate'),
            //   key: 2,
            //   function: () => statusChange([uuid], StatusChange.Duplicate),
            // },
          ]
        : []
      : []),

    ...(type == EnumStatus.Draft && canChangeStatus
      ? [
          {
            name: getI18n('voucher.storeVoucherList_config.issue'),
            key: 3,
            function: () => {
              statusChange([uuid], StatusChange.Issue);
            },
          },
        ]
      : []),
    ...(type !== EnumStatus.Archived && canChangeStatus
      ? [
          {
            name: getI18n('voucher.storeVoucherList_config.archive'),
            key: 5,
            function: () =>
              statusChangeModal([uuid], ModalType.ArchiveDiscount),
          },
        ]
      : []),
    ...(type == EnumStatus.Archived && canChangeStatus
      ? [
          {
            name: getI18n('voucher.storeVoucherList_config.restore'),
            key: 6,
            function: () => statusChange([uuid], StatusChange.ToDraft),
          },
        ]
      : []),
  ];
};

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },

  {
    url: '',
    name: getI18n('general.sider.voucher'),
  },
];

export const tabsConfig = [
  //定义tabs列表
  { name: getI18nFromGeneral('general.status.all'), key: '' },
  { name: getI18nFromGeneral('general.status.draft'), key: EnumStatus.Draft },
  { name: getI18nFromGeneral('general.status.active'), key: EnumStatus.Active },
  { name: getI18nFromGeneral('general.status.issued'), key: EnumStatus.Issued },
  {
    name: getI18nFromGeneral('general.status.expired'),
    key: EnumStatus.Expired,
  },
  {
    name: getI18nFromGeneral('general.status.archive'),
    key: EnumStatus.Archived,
  },
];

const status = (tab, { getI18n }) => {
  if (tab === EnumStatus.Archived) {
    return [];
  }
  if (tab === EnumStatus.Draft) {
    return [];
  }
  if (
    tab === EnumStatus.Active ||
    tab === EnumStatus.Expired ||
    tab === EnumStatus.Issued
  ) {
    return [
      // {
      //   type: EnumFilterType.MultipleSelection,
      //   dropdownProps: { name: ' Status' },
      //   keyWord: 'discountStatuses',
      //   options: [EnumStatus.Active, EnumStatus.Issued, EnumStatus.Expired].map(
      //     (item) => ({
      //       label: item,
      //       value: item,
      //     }),
      //   ),
      // },
    ];
  }
  return [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.status') },
      keyWord: 'discountStatuses',
      options: statusFilterList.map((item) => ({
        label: getI18n(item.labelKey),
        value: item.value,
      })),
    },
  ];
};

export const filterList = (tabsActive, dbs, salesChannels, { getI18n }) => [
  {
    type: EnumFilterType.SingleSelection,
    dropdownProps: {
      name: getI18n('voucher.storeVoucherList_config.customerDatabase'),
    },
    keyWord: 'customerDatabaseUuid',
    options: dbs.map((i) => {
      const { uuid, name } = i;
      return {
        label: name,
        value: uuid,
      };
    }),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.sider.salesChannel') },
    keyWord: 'salesChannelUuids',
    searchable: true,
    options: salesChannels.map((i) => {
      const { uuid, name } = i;
      return {
        label: name,
        value: uuid,
      };
    }),
  },
  ...status(tabsActive, { getI18n }),
  {
    type: EnumFilterType.SingleSelection,
    dropdownProps: { name: getI18n('general.type') },
    keyWord: 'discountTypes',
    options: Object.keys(typeFilterList).map((item) => ({
      label: getI18n(typeFilterList[item]),
      value: item,
    })),
  },
];
